export default function StreamOutputDescExternalBus({ output }) {
  return <>← EXT BUS {output.bus_id}</>;
}
